export class SearchFlybook {

  lidNr: number;
  date: string;
  material: string;
  place: string;
  remarks: string;
}
